require("./bootstrap");
var mediaelement = require("mediaelement");
var SmoothScroll = require("smooth-scroll");
import PropertyCard from "./components/PropertyCard.vue";
import Nav from "./components/Nav.vue";
if ($("#empower-app").length) {
    const app = new Vue({
        el: "#empower-app",
        components: {
            PropertyCard,
            ApplicationNav: Nav
        },
        methods: {
            toggleDropdown() {
                this.dropDown = !this.dropDown;
                var self = this;
                var timePointer;
                if (this.dropDown) {
                    timePointer = setTimeout(function() {
                        self.dropDown = false;
                        timePointer = null;
                    }, 5000);
                } else {
                    clearTimeout(timePointer);
                }
            }
        },
        mounted() {
            var scroll = new SmoothScroll('a[href*="#"]', {});
        },
        data: {
            dropDown: false
        }
    });
}
